<div class="row">
	<caass-personselector [AudienceID]="1"></caass-personselector>
</div>

<div *ngIf="alreadyAddedInQueue" class="alert alert-danger box-msg" role="alert">
	<strong>Student already added to Queue...</strong>
</div>

<div *ngIf="alreadyAddedInSubmittedList" class="alert alert-danger box-msg" role="alert">
	<strong>Student's ID had been sent to Print-Depot</strong>
</div>

<div *ngIf="submitLoading" class="alert alert-primary box-msg" role="alert">
	<strong>Submitting, Please wait...</strong>
</div>

<div *ngIf="addLoading" class="alert alert-primary box-msg" role="alert">
	<strong>Adding to queue list, Please wait...</strong>
</div>

<div *ngIf="RemoveLoading" class="alert alert-primary box-msg" role="alert">
	<strong>Removing from queue list, Please wait...</strong>
</div>

<div  class="busy-body">
	<p class="busy-message" [style.display]="IsBusy1 == true || IsBusy2 == true || IsBusy3 == true ? 'block' : 'none'" >Please wait, until selected student's information is loaded at right corner.</p>
	<p class="busy-message" [style.display]="IsBusy1 == false && IsBusy2 == false && IsBusy3 == false ? 'block' : 'none'" >Student information is loaded.</p>
</div>

<!-- 		 			   -->
<!-- Section - Lockout Msg -->
<!-- 			 	 	   -->
<div class="lockout-body" [style.display]="QueueIsLocked == true ? 'block' : 'none'">
	<label class="lockout-message">{{ LockoutMessage }}</label>
</div>

<!-- 		 			   -->
<!-- Section - Line Spacer -->
<!-- 			 	 	   -->
<div style="height: 20px; background-color: #ffffff;"></div>	<!-- Line Spacer -->

<!-- 		 			   -->
<!-- BUTTONS               -->
<!-- 			 	 	   -->
<button type="button" class="btn btn-primary" (click)="onAddStudentInQueueClick()" [disabled]="QueueIsLocked == true">Add</button>
&nbsp;

<button type="button" class="btn btn-primary" (click)="onPrintClick()" [disabled]="QueueIsLocked == true">Print Temp ID</button>

&nbsp;
<button type="button" class="btn btn-primary" (click)="onPrinterClick()" [disabled]="QueueIsLocked == true">Print Label Temp ID</button>

<div class="ibox float-e-margins">
	<div class="ibox-content">
		<div class="panel panel-default">
			<div class="panel-heading">
				<h5 class="panel-title">
					<a data-toggle="collapse" href="javascript:void(0);" data-parent="#accordion" data-target="#searchoption">Students in Queue.</a>
				</h5>
			</div>

			<div id="searchoption" class="panel-collapse">
				<div class="panel-body">
					<div ngIF="showActionTable">
						<table class="table table-striped table-hover" my-table options="options" width="100%">
							<thead>
								<tr>
									<th>Student ID</th>
									<th>Student Name</th>
									<th>Print/Remove</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let student of lstStudents">
									<td>
										{{ student.StudentID }}
									</td>
									<td>
										{{ student.FirstName }}
										{{ student.LastName }}
									</td>
									<td>
										<button type="button" class="btn btn-primary" [disabled]="QueueIsLocked == true" (click)="onSubmitClick($event, student.PersonID)" id="oneSubmitButton">
											Print
										</button>
										<button type="button" class="btn btn-danger" [disabled]="QueueIsLocked == true" (click)="onRemoveClick($event, student.PersonID)">Remove</button>
									</td>
								</tr>
							</tbody>
						</table>
						<button type="button" class="btn btn-primary" (click)="onSubmitAllClick()" [disabled]="QueueIsLocked == true">Print All</button>
						<button type="button" class="btn btn-danger" (click)="openConfirmationDialog()" [disabled]="QueueIsLocked == true">Remove All</button>
					</div>
					<br />
					<br />
					<div></div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<div class="panel panel-default">
					<div class="panel-heading">
						<h5 class="panel-title">
							<a data-toggle="collapse" href="javascript:void(0);" data-parent="#accordion" data-target="#searchoption"
								>Students sent for Print-Depot.
							</a>
						</h5>
					</div>
					<div id="searchoption" class="panel-collapse">
						<div class="panel-body"></div>
						<div ngIF="showActionTable">
							<table class="table table-striped table-hover" my-table options="options">
								<thead>
									<tr>
										<th>Student ID</th>
										<th></th>
										<th>Student Name</th>
										<th>Status</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let std of lstStudentNotInQueue">
										<td>{{ std.StudentID }}</td>
										<td></td>
										<td>
											{{ std.FirstName }}
											{{ std.LastName }}
										</td>

										<td>{{ std.PrintStatus }}</td>
										<td></td>
										<td></td>
										<td></td>

										<td></td>
										<td></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<p-confirmDialog></p-confirmDialog>
